
import styled from 'styled-components';
import Input from '../../../../element/ui/core/input';
import Select from '../../../../element/ui/core/select';

const StyledFontFamilySelect = styled(Select)`
  width: 100%;
  margin: 0;

  .respark_Select-Container {
    width: 100%;
  }

  .respark_Select-root {
    overflow: hidden;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    min-height: 28px;
    height: 28px;
    max-height: 28px;
    padding: 0 8px 0 10px;
    text-align: left;
  }

  .respark_Select-Label {
    display: block;
    flex: 1 1 auto;
    align-items: center;
    justify-content: flex-start;
    min-width: 0;
    overflow: hidden;
    line-height: 1.15;
    max-height: 100%;
    text-align: left;
  }

  .respark_Select-Icon {
    flex-shrink: 0;
    margin-left: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    min-width: 14px;

    svg {
      width: 10px !important;
      height: 10px !important;
      max-width: 10px;
      max-height: 10px;
    }
  }

  .respark-font-family-trigger-label {
    display: block;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
    font-size: 13px;
    line-height: 1.15;
    max-height: 1.15em;
  }
`;

const StyledFontSizeInput = styled(Input)`
  width: 100%;
  margin: 0;
  min-height: 28px;
  padding: 4px 8px;
  border: 1px solid #dee1ec;
  border-radius: 10.9px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  box-sizing: border-box;

  &:focus-within {
    border-color: #b8c4d9;
    background: #fff !important;
  }

  &:hover {
    background: #fff;
  }

  input {
    border-radius: 10.9px;
    text-align: right;
  }
`;

export { StyledFontFamilySelect, StyledFontSizeInput };
